'use client';

import Link from 'next/link';
import { getButtonVariant } from '@workspace/lib';
import { isInternalHref, scrollToTopAfterNavigation } from '@workspace/lib/common/Button/button.utils';
import { stripInvisibles } from '@workspace/constants';
import { Button, Icon } from '@workspace/ui/common';
import { CTAItem } from '../product-summary.types';

interface ProductSummaryCTAProps {
  ctaItems: CTAItem[];
  onAskGregClick: () => void;
  getOpenInNewTab: (item: CTAItem) => boolean;
}

export function ProductSummaryCTA({ ctaItems, onAskGregClick, getOpenInNewTab }: ProductSummaryCTAProps) {
  if (!ctaItems?.length) return null;

  return (
    <div className="order-2 w-full md:w-auto flex flex-wrap md:gap-sm gap-xs lg:justify-start justify-center">
      {ctaItems.map((item, index) => {
        const openInNewTab = getOpenInNewTab(item);
        const label = stripInvisibles(item.text || '').trim();
        const href = item.url || '#';

        if (item.type === 'button') {
          return (
            <Button
              key={index}
              variant={getButtonVariant(item.buttonStyle)}
              url={item.url}
              openInNewTab={openInNewTab}
              className="leading-5 w-full md:w-auto"
            >
              {label}
            </Button>
          );
        }

        if (item.type === 'askGreg') {
          return (
            <Button
              key={index}
              variant={getButtonVariant(item.buttonStyle)}
              onClick={onAskGregClick}
              className="leading-5 w-full md:w-auto"
            >
              {label || 'Ask Greg'}
            </Button>
          );
        }

        // hyperlink type
        return (
          <div className="button-container group flex justify-start gap-1 items-center w-full md:w-auto" key={index}>
            <Link
              href={href}
              onClick={() => {
                if (!openInNewTab && !href.startsWith('#') && isInternalHref(href)) {
                  scrollToTopAfterNavigation();
                }
              }}
              target={openInNewTab ? '_blank' : undefined}
              rel={openInNewTab ? 'noopener noreferrer' : undefined}
              className="text-primary transition-colors font-semibold text-base leading-md py-2"
            >
              {label || 'Button text'}
            </Link>
            <Icon
              name="arrowRightIcon"
              size={24}
              className="transition-transform duration-300 ease-in-out group-hover:translate-x-1 text-primary"
            />
          </div>
        );
      })}
    </div>
  );
}
